<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

  <sc-dialog-title>{{'manage planned assignments' |
    translate:['tmc-yard.widgets.sac-client.manage-planned-assignments.title',
    translationService.language]}}</sc-dialog-title>


  <sc-flex-fitting-content [vertical]="true">
    <sc-padding [fitHeight]="true">

      <sc-flex [vertical]="false" [fitHeight]="true" [stretchContent]="true">

        <div style="height: 100%;">
          <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

            <sc-sub-title>
              {{'planned assignments' |
              translate:['tmc-yard.widgets.sac-client.manage-planned-assignments.planned-assignment-list.title',
              translationService.language]}}
            </sc-sub-title>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <sc-flex-fitting-content [vertical]="true">
              <sc-scroll-pane>
                <div class="transport-list">
                  <ng-container *ngFor="let plannedAssignment of plannedTransportAssignments">

                    <app-planned-assignment-list-entry [transportDetails]="plannedAssignment.transport"
                      [selected]="selectedPlannedTransportAssignmentId != null && plannedAssignment.transportAssignmentId === selectedPlannedTransportAssignmentId"
                      (click)="setSelectedAssignment(plannedAssignment)"></app-planned-assignment-list-entry>

                    <ng-container
                      *ngIf="selectedPlannedTransportAssignmentId != null && plannedAssignment.transportAssignmentId === selectedPlannedTransportAssignmentId">
                      <app-planned-assignment-details-list-entry
                        [transportDetails]="plannedAssignment.transport"></app-planned-assignment-details-list-entry>
                    </ng-container>

                    <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
                  </ng-container>
                </div>
              </sc-scroll-pane>
            </sc-flex-fitting-content>

            <sc-content-spacer [vertical]="true"></sc-content-spacer>

            <button mat-stroked-button [disabled]="this.selectedPlannedTransportAssignmentId == null"
              (click)="cancelPlannedAssignment()">{{'cancel planned assignment' |
              translate:['tmc-yard.widgets.sac-client.manage-planned-assignments.action.cancel-planned-assignment',
              translationService.language]}}</button>

          </sc-flex>
        </div>

        <sc-content-spacer></sc-content-spacer>

        <sc-flex-fitting-content>
          <div style="height: 100%;">
            <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

              <sc-sub-title>
                {{'planned transports' |
                translate:['tmc-yard.widgets.sac-client.manage-planned-assignments.planned-transports-list.title',
                translationService.language]}}
              </sc-sub-title>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <sc-flex-fitting-content [vertical]="true">
                <sc-scroll-pane>
                  <app-planned-transport-selection [targetStationId]="targetStation.id" [onlyPlanned]="false"
                    [findOnlyNextPlannedRoutingPosition]="false"
                    (selectedTransport)="transportSelected($event)"></app-planned-transport-selection>
                </sc-scroll-pane>
              </sc-flex-fitting-content>

              <sc-content-spacer [vertical]="true"></sc-content-spacer>

              <button mat-stroked-button [disabled]="this.selectedTransportId == null"
                (click)="createPlannedAssignment()">{{'create planned assignment' |
                translate:['tmc-yard.widgets.sac-client.manage-planned-assignments.action.create-planned-assignment',
                translationService.language]}}</button>
            </sc-flex>
          </div>

        </sc-flex-fitting-content>

      </sc-flex>

    </sc-padding>
  </sc-flex-fitting-content>


  <sc-padding>
    <sc-flex>
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
      <sc-content-spacer [grow]="true"></sc-content-spacer>
      <button mat-stroked-button mat-dialog-close>{{'close' |
        translate:['tmc-yard.widgets.sac-client.manage-planned-assignments.action.close',
        translationService.language]}}</button>
    </sc-flex>
  </sc-padding>

</sc-flex>
